/*ture 网关模式， false 普通模式*/
/*** 返回消息类型 info */
export const MSG_TYPE_FAIL = 0
/*** 返回消息类型 success */
export const MSG_TYPE_SUCCESS = 1

/*** TREE跟节点 */
export const TREE_ROOT = '-1'

/*** 否 */
export const SYS_NO = '0'
/*** 是 */
export const SYS_YES = '1'

export const DICT_SYS_DATA = {
  是: { class: ' m-badge--info' },
  否: { class: ' m-badge--warning' },
}
